import React, { useState } from "react";
import { supabase } from "../supabaseClient";
import "../styles/ChooseProfileName.css";

const ChooseProfileName: React.FC<{
  onSuccess: () => void;
  onClose: () => void;
}> = ({ onSuccess, onClose }) => {
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [exitAnim, setExitAnim] = useState(false); // 🔧 uusi tila

  const handleSubmit = async () => {
    setError("");
    setLoading(true);

    const {
      data: { user },
      error: authError,
    } = await supabase.auth.getUser();

    if (authError || !user) {
      setError("Käyttäjätietojen hakeminen epäonnistui");
      setLoading(false);
      return;
    }

    const { data: existing } = await supabase
      .from("users")
      .select("id")
      .eq("display_name", name)
      .maybeSingle();

    if (existing) {
      setError("Profiilinimi on jo käytössä");
      setLoading(false);
      return;
    }

    const { error: insertError } = await supabase.from("users").insert([
      {
        id: user.id,
        email: user.email,
        display_name: name,
      },
    ]);

    if (insertError) {
      setError("Tallennus epäonnistui: " + insertError.message);
    } else {
      onSuccess();
    }

    setLoading(false);
  };

  const handleClose = async () => {
    setExitAnim(true);
    setTimeout(async () => {
      await supabase.auth.signOut(); // kirjaa ulos
      onClose(); // sulkee modalin
    }, 300); // sama kuin animaation kesto
  };

  return (
    <div className="choose-profile-backdrop">
      <div
        className={`choose-profile-content ${
          exitAnim ? "choose-profile-exit" : ""
        }`}
      >
        <button className="choose-profile-close-button" onClick={handleClose}>
          ×
        </button>
        <h2>Valitse profiilinimi</h2>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Profiilinimi"
        />
        <button onClick={handleSubmit} disabled={loading || name.trim() === ""}>
          {loading ? "Tallennetaan..." : "Tallenna"}
        </button>
        {error && <p className="error-text">{error}</p>}
      </div>
    </div>
  );
};

export default ChooseProfileName;
